"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./Form.css");
var Link_1 = __importDefault(require("../Link"));
var Button_1 = __importDefault(require("../Button"));
var Alert_1 = __importDefault(require("../Alert"));
var validator_1 = require("../validator");
function Form(_a) {
    var alertText = _a.alertText, _b = _a.alertAppearance, alertAppearance = _b === void 0 ? "danger" : _b, children = _a.children, link = _a.link, submitting = _a.submitting, submitLabel = _a.submitLabel, onClickSubmit = _a.onClickSubmit, buttonLabel = _a.buttonLabel, onClickButton = _a.onClickButton, _c = _a.textValidation, textValidation = _c === void 0 ? {} : _c;
    var _d = (0, validator_1.useForm)(), isSubmit = _d.isSubmit, setFields = _d.setFields, handleSubmit = _d.handleSubmit;
    var renderLink = link && (React.createElement(Link_1.default, { href: link.href, onClick: link.onClick }, link.children));
    var renderButton = onClickButton && buttonLabel && (React.createElement("div", { className: "nimbus--action-wrapper__item" },
        React.createElement(Button_1.default, { onClick: onClickButton }, buttonLabel)));
    var onSubmit = function (_a) {
        var data = _a.data, formIsValid = _a.formIsValid;
        if (!formIsValid) {
            return;
        }
        onClickSubmit(data);
    };
    return (React.createElement("div", { "data-testid": "Form", className: "nimbus--form" },
        alertText && (React.createElement(Alert_1.default, { appearance: alertAppearance, show: true }, alertText)),
        React.createElement("form", { action: "" },
            React.createElement(validator_1.ValidationsContextProvider, null,
                React.createElement(validator_1.FieldsContainer, { isSubmit: isSubmit, setFields: setFields, textValidation: textValidation }, children))),
        renderLink,
        React.createElement("div", { className: "nimbus--form__actions" },
            renderButton,
            React.createElement("div", { className: "nimbus--action-wrapper__item" },
                React.createElement(Button_1.default, { appearance: "primary", onClick: handleSubmit(onSubmit), spinner: submitting, disabled: submitting }, submitLabel)))));
}
exports.default = Form;
//# sourceMappingURL=index.js.map